import { render, staticRenderFns } from "./AddAndEditTag.vue?vue&type=template&id=3df7eec6"
import script from "./AddAndEditTag.vue?vue&type=script&lang=js"
export * from "./AddAndEditTag.vue?vue&type=script&lang=js"
import style0 from "./AddAndEditTag.vue?vue&type=style&index=0&id=3df7eec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports